import * as React from "react";
import { User } from '../models/User';
import { getResourceString } from '../kentico/resource-strings';

export const DigitaleLedenpasLidnummerNaam = (props: User) => {
    return <>   
        <div className="digitaleledenpas__info row no-gutters">
            <div className="col-12 row">
                <span className="col-6">
                    <span className="digitaleledenpas__info-label">{getResourceString("Memberpass.MemberNumber.Label")}</span>
                </span>
                <span className="col-6">
                    <span className="digitaleledenpas__info-data">{props.lidnummer}</span>
                </span>
            </div>
            <div className="col-12 row">
                <span className="col-6">
                    <span className="digitaleledenpas__info-label">{getResourceString("Memberpass.Name.Label")}</span>
                </span>
                <span className="col-6">
                    <span className="digitaleledenpas__info-data">{props.name}</span>
                </span>
            </div>
            <div className="col-12 row">
                <span className="col-6">
                    <span className="digitaleledenpas__info-label">{getResourceString("Memberpass.BirthDate.Label")}</span>
                </span>
                <span className="col-6">
                    <span className="digitaleledenpas__info-data">{props.birthDate}</span>
                </span>
            </div>
            <div className="col-12 row">
                <span className="col-6">
                    <span className="digitaleledenpas__info-label">{getResourceString("Memberpass.RightsDate.Label")}</span>
                </span>
                <span className="col-6">
                    <span className="digitaleledenpas__info-data">{props.membershipCardActivatedDate}</span>
                </span>
            </div>
        </div>
    </>;
}
;